
import { Injectable } from '@angular/core';

@Injectable()
export class CkeConfiqService {
  private confiq = {
    stylesSet: [
      { name: 'Heading 4', element: 'h4'}
    ],
    toolbar: [
      [
        'Bold',
        'Italic',
        'BulletedList',
        'Styles'
      ],
      ['Table'],
      ['Image']
    ]
  };

  constructor() { }


  public getckeconfig() {
    return this.confiq;
  }
}
